import { getMethodUnexpectedArgsErrorMsg } from './errorMessages';
import { GenericEvent } from './GenericEvent';

interface CallArgs {
  domain: string;
  serviceName: string;
  name: string;
  hasParams: boolean;
  args: any[];
}

export function callToMessage({ domain, serviceName, name, hasParams, args }: CallArgs): GenericEvent {
  const expectedParamsNumber = hasParams ? 1 : 0;
  if (args.length !== expectedParamsNumber && process.env.NODE_ENV !== 'production') {
    console.error(new Error(getMethodUnexpectedArgsErrorMsg(domain, serviceName, name)))
  }

  return {
    name,
    domain,
    serviceName,
    payload: hasParams ? args[0] : {},
  };
}
